var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileScreenEditProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18C0 8.05888 8.05888 0 18 0C27.9411 0 36 8.05888 36 18V36H18C8.05888 36 0 27.9411 0 18Z",
    fill: "#C2B58C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.838 9C25.3851 9 25.8285 9.44772 25.8285 10V11.757L23.8475 13.757V11H9.98094V19.1L13.9428 15.1005L18.2296 19.429L16.9154 20.7562L16.9093 24.995L21.1152 25.0012L22.4322 23.671L23.748 25H23.8475V22.242L25.8285 20.242V26C25.8285 26.5523 25.3851 27 24.838 27H8.99047C8.44345 27 8 26.5523 8 26V10C8 9.44772 8.44345 9 8.99047 9H24.838ZM26.5993 13.8076L28 15.2218L20.2959 23L18.8931 22.9979L18.8952 21.5858L26.5993 13.8076ZM20.3809 13C21.2014 13 21.8666 13.6716 21.8666 14.5C21.8666 15.3284 21.2014 16 20.3809 16C19.5604 16 18.8952 15.3284 18.8952 14.5C18.8952 13.6716 19.5604 13 20.3809 13Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileScreenEditProfileIcon);
export default __webpack_public_path__ + "static/media/profile-screen-edit-profile-icon.ef7cca40fafbbe899a9ec2f355c0af56.svg";
export { ForwardRef as ReactComponent };